import React, { ReactNode } from "react";
import "./recipe-tips.scss";

export type RecipeTipsProps = {
  children?: ReactNode;
};

export function RecipeTips({ children }: RecipeTipsProps) {
  return <div className="recipe-tips">{children}</div>;
}
